import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import { ApproveCreditRequest } from "../../../utils/Credit";

import "./styles.css";

export const AcceptTermsDetail = ({ approvalConfirmationId }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    async function fetchApproval() {
      try {
        const {status} = await ApproveCreditRequest(approvalConfirmationId);

        if (status === 200) {
          setError(false);
        } else {
          setError(true);
        }
      } catch (error) {
        setError(true);
      } finally {
        setLoading(false);
      }
    }

    fetchApproval();
  }, [approvalConfirmationId]);

  return (
    <div class="c-table-5__container">
      {loading === true ? (
        <div class="c-table-5__container_Progress">
          <CircularProgress />
        </div>
      ) : (
        <div class="pay">
          {!error ? (
            <div class="message-success">
              <span class="highlight">🎉¡Felicidades, tu crédito fue aprobado!🎉</span><br /><br />
              Gracias por confiar en nosotros. Muy pronto estarás disfrutando de tu moto.<br /><br />
              ¡Ojo! 👀 Esta aprobación depende de que todos tus datos estén bien. Si todo está en orden, tu crédito sigue adelante sin problema.
            </div>
          ) : (
            <div class="message-error">
              <span class="highlight">Tuvimos un inconveniente al procesar tu información.</span><br /><br />
              Te recomendamos comunicarte con tu asesor para revisar los detalles y continuar con el proceso.
            </div>
          )}
          <div className="o-btn-pc">
            <Link to={"/"}>
              <button className={"o-btn-3--v2"}>Volver al inicio</button>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};
